module.exports = __webpack_public_path__ + "static/media/logo-footer_.2ecd48bf.svg";